import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchBookingV4FromAPI } from "../APIs/Booking/GetBooking";
import { fetchCustomerFromAPI } from "../APIs/Customer/GetCustomer";
import { useCustomerContext } from "./useCustomerContext";
import { useDiaryContext } from "./useDiaryContext";

export const useSelectedBookingAPIData = () => {
  const diaryContext = useDiaryContext();
  const { selectedBooking, setDiaryContext } = diaryContext;
  const customerId = selectedBooking?.customerId;
  const selectedBookingId = selectedBooking?.id;

  const { setSelectedCustomer } = useCustomerContext();

  const { data: selectedBookingV4Response } = useQuery({
    queryKey: ["getSelectedBooking", selectedBookingId],
    queryFn: () =>
      selectedBookingId ? fetchBookingV4FromAPI(selectedBookingId) : undefined,
    enabled: !!selectedBookingId
  });

  const { data: customerResponse } = useQuery({
    queryKey: ["getCustomer", customerId],
    queryFn: () =>
      customerId ? fetchCustomerFromAPI({ customerId }) : undefined,
    enabled: !!customerId
  });

  useEffect(() => {
    if (!customerResponse?.customer) {
      return;
    }

    setSelectedCustomer(customerResponse?.customer);
  }, [customerResponse]);

  useEffect(() => {
    if (!selectedBookingV4Response) {
      return;
    }
    if (!customerId) {
      setSelectedCustomer(undefined);
    }
    setDiaryContext({ selectedBookingV4: selectedBookingV4Response });
  }, [selectedBookingV4Response]);
};
